import { useMemo, useState } from "react";
import "@/App.css";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/ui/tabs";
import { Header } from "./components/Header";
import { BasicInputs } from "./components/BasicInputs";
import { ActivityTable } from "./components/ActivityTable";
import { Results } from "./components/Results";
import { PrintReport } from "./components/PrintReport";
import { UvjetiPregled, ObvezePregled } from "./components/InfoPanels";
import { calculatePoints, evaluate } from "./lib/calculator";

const INITIAL_BASIC = { role: "ucitelj", staz: "", kpr: "", prevYears: "" };

export default function App() {
  const [target, setTarget] = useState("mentor");
  const [basic, setBasic] = useState(INITIAL_BASIC);
  const [counts, setCounts] = useState({});

  const calc = useMemo(() => calculatePoints(counts), [counts]);
  const result = useMemo(() => evaluate(target, basic, calc), [target, basic, calc]);

  const reset = () => {
    setBasic(INITIAL_BASIC);
    setCounts({});
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="w-full max-w-6xl mx-auto p-4 sm:p-6">
        <Header />

        <Tabs defaultValue="kalkulator" className="no-print">
          <TabsList className="bg-slate-100 mb-5 flex-wrap h-auto">
            <TabsTrigger value="kalkulator" data-testid="tab-kalkulator">Kalkulator</TabsTrigger>
            <TabsTrigger value="uvjeti" data-testid="tab-uvjeti">Uvjeti za zvanja</TabsTrigger>
            <TabsTrigger value="obveze" data-testid="tab-obveze">Obveze u zvanju</TabsTrigger>
          </TabsList>

          <TabsContent value="kalkulator">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
              <div className="lg:col-span-7 space-y-6">
                <BasicInputs basic={basic} setBasic={setBasic} target={target} setTarget={setTarget} />
                <ActivityTable counts={counts} setCounts={setCounts} byCategory={calc.byCategory} />
              </div>
              <div className="lg:col-span-5 lg:sticky lg:top-4">
                <Results target={target} basic={basic} counts={counts} calc={calc} result={result} onReset={reset} />
              </div>
            </div>
          </TabsContent>

          <TabsContent value="uvjeti">
            <UvjetiPregled />
          </TabsContent>

          <TabsContent value="obveze">
            <ObvezePregled />
          </TabsContent>
        </Tabs>

        <footer className="mt-8 pb-4 text-xs text-slate-400 leading-relaxed no-print" data-testid="app-footer">
          Kalkulator je informativnog karaktera i ne predstavlja službeno tumačenje propisa. Odluku o
          napredovanju donosi nadležna agencija na temelju Pravilnika o napredovanju učitelja, nastavnika,
          stručnih suradnika i ravnatelja u osnovnim i srednjim školama i učeničkim domovima (NN 68/2019)
          i njegovih izmjena i dopuna (NN 32/2021).
        </footer>

        <PrintReport basic={basic} target={target} counts={counts} calc={calc} result={result} />
      </div>
    </div>
  );
}
